// investments table field → AppContext state key (same pairs Others.js submits)
export const INVESTMENT_FIELDS = {
  bank_balance: 'bankBalance',
  fixed_deposit: 'fixedDeposit',
  retirement_fund: 'retirementFund',
  bonds: 'bonds',
  debt_mf: 'debtMF',
  equity_mf: 'equityMF',
  hybrid_mf: 'hybridMF',
  invits: 'invits',
  stocks: 'stocks',
  pms: 'pms',
  unlisted: 'unlisted',
  global_equity: 'globalEquity',
  global_bonds: 'globalBonds',
  global_mf: 'globalMF',
  real_estate: 'realEstate',
  gold: 'gold',
  other_investments: 'otherInvestments',
};

/** Writes fetched totals ({ equity_mf: 123.4, ... }) into the form state as whole rupees. */
export const applyFetchedTotals = (fields, updateFormData) => {
  Object.entries(fields || {}).forEach(([field, value]) => {
    const key = INVESTMENT_FIELDS[field];
    if (key) updateFormData(key, Math.round(Number(value) || 0));
  });
};

/** Full investments payload: current form values, overridden by fetched totals. */
export const buildInvestmentPayload = (state, fields = {}) =>
  Object.fromEntries(
    Object.entries(INVESTMENT_FIELDS).map(([field, key]) => [
      field,
      field in fields ? Math.round(Number(fields[field]) || 0) : state[key],
    ]),
  );
